<template lang="pug">
  .b-change
    ._text Ответственный
    ._tile.old
      UserAvatar._avatar(:user="oldUser")
      ._name(v-if="oldUser") {{ oldUser.name }} {{ oldUser.surname }}
    ._arrow
    ._tile
      UserAvatar._avatar(:user="newUser")
      ._name(v-if="newUser") {{ newUser.name }} {{ newUser.surname }}
</template>

<script>
import UserAvatar from '@/components/UserAvatar.vue';

export default {
  name: 'TaskChangeManager',
  components: { UserAvatar },
  props: {
    change: Object,
  },
  computed: {
    oldUser() { return this.change.users.find((u) => u?.id === this.change.info.old); },
    newUser() { return this.change.users.find((u) => u?.id === this.change.info.new); },
  },
};
</script>

<style scoped lang="scss">
  .change {
    display: flex;
    align-items: center;
    column-gap: 30px;

    &__text {
      font-size: 11px;
      line-height: 14px;
      letter-spacing: 0.01em;
      color: #1E3147;
      opacity: 0.5;
    }

    &__avatar {
      width: 32px;
      height: 32px;
      border-radius: 12px;
    }

    &__name {
      font-size: 11px;
      line-height: 14px;
      letter-spacing: 0.01em;
      color: #1E3147;
      opacity: 0.5;
    }

    &__tile {
      display: flex;
      align-items: center;
      gap: 6px;
    }

    &__arrow {
      display: flex;
      align-items: center;
      margin: 0 -20px;

      &:before {
        content: '';
        display: block;
        width: 25px;
        height: 2px;
        background: #D1D9F0;
      }

      &:after {
        content: '';
        display: block;
        border: 4px solid transparent;
        border-left-color: #D1D9F0;
      }
    }
  }
</style>
